import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PvRecruitmentComponent} from './pv-recruitment.component';
import {PvRecruitmentProcessComponent} from './pv-recruitment-process/pv-recruitment-process.component';
import {PvRecruitmentRegistrationComponent} from './pv-recruitment-registration/pv-recruitment-registration.component';
import {RecruitmentGuard} from '../../shared/guards/recruitment.guard';

const routes: Routes = [
  {
    path: '',
    component: PvRecruitmentComponent,
  },
  {
    path: 'inscription',
    component: PvRecruitmentRegistrationComponent,
  },
  {
    path: 'recruitment-process',
    canActivate: [RecruitmentGuard],
    component: PvRecruitmentProcessComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PvRecruitmentRoutingModule { }
